module.exports = __webpack_public_path__ + "static/pricing-8d2ef0fb9c13f80a971e69318aafb83f.png";